import React from "react";

const SlideshowImage = (props) => {
    
    const { image, settings } = props;
    const { src, alt } = image || {};
    let position = "center center";
    const { options, format } = settings || {};
    if (format === "image.format.cropped-focus") {
        position = options?.position;
    }
    
    if (image) {
        return (
            <div
                className='home-banner-image'
                title={alt}
                style={{
                    width: "100%",
                    backgroundImage: `url(${src})`,
                    backgroundSize: "cover",
                    backgroundPosition: `${position}`,
                }}
            >
            </div>
        );
    } else {
        return (
            <div className='slideshow-loading'>
                <div className='loader'>
                </div>
            </div>
        );
    }
};

export { SlideshowImage }; 